/**
 *
 * @module entry
 * @desc {SDK.Identity.Adobe} entry point.
 *
 */

import AdobeIdentityApi from './adobeIdentityApi';
import AdobeIdentityManager from './adobeIdentityManager';
import AdobeRegistration from './adobeRegistration';
import AdobeActivationResult from './adobeActivationResult';

/**
 *
 * @typedef SDK.Identity.Adobe
 * @type {Object}
 *
 * @property {AdobeIdentityApi} AdobeIdentityApi
 * @property {AdobeIdentityManager} AdobeIdentityManager
 * @property {AdobeRegistration} AdobeRegistration
 * @property {AdobeActivationResult} AdobeActivationResult
 *
 */

/**
 *
 * @type {SDK.Identity.Adobe}
 *
 */
export default {

    AdobeIdentityApi,
    AdobeIdentityManager,
    AdobeRegistration,
    AdobeActivationResult

};



// WEBPACK FOOTER //
// ./src/identity/adobe/entry.js